import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { LocalPanelRoute } from "./routes/local-panel.tsx";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/local" replace />} />
        <Route path="/local" element={<LocalPanelRoute />} />
        <Route path="/local/:documentId" element={<LocalPanelRoute />} />
        <Route path="*" element={<Navigate to="/local" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
